import { GetBeneficiariosSuccess, GetEstudioBeneficiarioSuccess } from '../actions/beneficiarios.actions';
import { IBeneficiario } from 'src/app/interfaces/beneficiarios.interface';
import { createReducer, on } from '@ngrx/store';

export interface IBeneficiariosState {
  beneficiarios: IBeneficiario[];
  estudio: object;
}

export const initialBeneficiariosState: IBeneficiariosState = {
  beneficiarios: [],
  estudio: {}
};

export const beneficiariosReducers = createReducer(
  initialBeneficiariosState,
  on(GetBeneficiariosSuccess, (state, { beneficiarios }) => {
    return {
        ...state,
        beneficiarios
    };
  }),
  on(GetEstudioBeneficiarioSuccess, (state, { estudio }) => {
    return {
        ...state,
        estudio
    };
  })
);
